import { SplatEffectsLayer } from '../../../SplatEffectsLayer';
import { BodyTypes } from "../../../LevelManager";
import { ObstacleSpine } from "./ObstacleSpine";

export class ObstacleInk extends ObstacleSpine {
  public static animations = {
    Idle: 'ink-idle',
    Squirt: 'ink-squirt',
    HitEffect: 'ink-splash',
  } as const;

  constructor(scene: Phaser.Scene,x: number, y: number) {
    super(scene, x, y, 'ink', ObstacleInk.animations.Idle);

    this.injectMatter(this as unknown as Phaser.GameObjects.GameObject);
    this.addToUpdateList();
  }

  public init() { }

  public onFire() {
    this.setAnimation(0, ObstacleInk.animations.Squirt, false);
    this.addAnimation(0, ObstacleInk.animations.Idle, true);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    let x = this.x;
    let y = this.y;

    this.scene.matter.add.gameObject(target, {
      label: BodyTypes.Obstacle,
      isStatic: true,
      isSensor: true
    }) as Phaser.Physics.Matter.Sprite;

    (target.body as MatterJS.BodyType).scale.x = 0.8;
    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(x, y));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  public override onHit(wasPlayer: boolean, hitPointX: number, delay: number): void {
    this.scene.events.emit(SplatEffectsLayer.events.SplatOil, hitPointX - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY, 5);
    this.setAnimation(0, ObstacleInk.animations.HitEffect, false);
    this.hasBeenHit = true;

    // this.scene.add.tween({
    //   targets: this,
    //   alpha: 0,
    //   duration: 250,
    //   ease: Phaser.Math.Easing.Circular.InOut,
    //   delay: delay,
    //   onComplete: () => {
    //     this.hasBeenHit = true;
    //   },
    //   onCompleteScope: this
    // });
  }
}
